/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Corner, getColor } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';
import { responsiveTextStyle } from '../../utils/responsiveTextStyle';

const styles = StyleSheet.create((pd) => ({
  container: {
    gap: pd.ref.space.spacing40.px,
  },
  separator: {
    height: 1,
    marginVertical: pd.ref.space.spacing20.px,
    backgroundColor: getColor(pd.sys.colour.outline_low),
  },
  listContent: {
    height: pd.ref.space.spacing80.px,
    alignSelf: 'stretch',
    justifyContent: 'center',
    borderRadius: Corner.MEDIUM,
    borderColor: getColor(pd.sys.colour.container_low),
    backgroundColor: getColor(pd.sys.colour.container_low),
  },
  endElement: {
    marginTop: 0,
  },
  optionsContainer: {
    gap: pd.ref.space.spacing20.px,
  },
  descriptionContainer: {
    alignSelf: 'stretch',
    alignItems: 'center',
  },
  heading: responsiveTextStyle(
    pd.sys.typescale.sub_body_text_medium,
    pd.sys.typescale.heading_3,
    pd.sys.colour.content_primary,
  ),
  optionLabel: responsiveTextStyle(
    pd.sys.typescale.sub_body_text,
    pd.sys.typescale.body_text,
    pd.sys.colour.content_primary,
  ),
  description: responsiveTextStyle(
    pd.sys.typescale.sub_body_text,
    pd.sys.typescale.body_text,
    pd.sys.colour.content_secondary,
  ),
}));

export default styles;
